import { render, staticRenderFns } from "./LayoutBrain.vue?vue&type=template&id=94ecb18c"
import script from "./LayoutBrain.vue?vue&type=script&lang=js"
export * from "./LayoutBrain.vue?vue&type=script&lang=js"
import style0 from "./LayoutBrain.vue?vue&type=style&index=0&id=94ecb18c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports